import { render, staticRenderFns } from "./IconTextToSpeech.vue?vue&type=template&id=1c172939&"
import script from "./IconTextToSpeech.vue?vue&type=script&lang=ts&"
export * from "./IconTextToSpeech.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports